import $ from 'jquery';

function isMobile () {
  return window.innerWidth < 680;
}

function hideContent () {
  $('.js-nav-menu-content').hide();
}

export default class Nav {
  init () {
    hideContent();
    // console.log('Nav init');

    // Back button on mobile
    $('.js-nav-menu-back').on('click', function (event) {
      hideContent();
      $('.js-nav-menu-link').show();
    });

    // Click on mobile
    $('.js-nav-menu-link').on('click', function (event) {
      const $content = $(this).parent().find('.js-nav-menu-content');

      if (isMobile() && $content.length) {
        event.preventDefault();
        $('.js-nav-menu-link').hide();
        $content.fadeIn(300);
      }
    });

    // Hover on desktop
    $('.js-nav-menu-link').on('mouseenter', function (event) {
      const $key = $(this).data('menu-key');
      const $content = $(this).parent().find('.js-nav-menu-content');

      $('.js-nav-menu-image-' + $key).toggleClass('show');

      if (!isMobile()) {
        hideContent();

        if ($content.length) {
          console.log('SHOW CONTENT...');
          $content.fadeIn(300);
        }
      }
    });

    // Hover leave on desktop
    $('.js-nav-menu-link').on('mouseleave', function (event) {
      const $key = $(this).data('menu-key');

      setTimeout(() => {
        $('.js-nav-menu-image-' + $key).toggleClass('show');
      }, 250);
    });
  }
}
